import * as Sentry from '@sentry/react';

import { isApiHttpError } from '@/lib/api-error';

/**
 * Failed API responses from customFetch are already logged on the server.
 * Do not re-report 4xx/5xx as frontend issues. Keep real UI exceptions.
 */
export const shouldReportErrorToSentry = (error: unknown): boolean =>
  !isApiHttpError(error);

/**
 * Capture `error` in Sentry unless it is a customFetch HTTP 4xx/5xx.
 * Returns the event id when reported, otherwise `undefined`.
 */
export const captureReportableException = (
  error: unknown
): string | undefined => {
  if (!shouldReportErrorToSentry(error)) {
    return undefined;
  }
  return Sentry.captureException(error);
};
